<template>
  <CommunityCard class="post-card">
    <template #header>
      <div class="titlerow mb-3">
        <div>
          <h5 class="d-inline-block post-title">
            <strong>
              {{ postObj.creator.first_name + " " + postObj.creator.last_name }}
            </strong>
            shared a post
            <template v-if="groupObj">
              in <strong>{{ groupObj.name }}</strong>
            </template>
          </h5>

          <div>
            <span
              class="time-text"
              data-toggle="tooltip"
              :title="getFullDate(postObj.created_at)"
            >
              {{ getPrettyDate(postObj.created_at) }}
            </span>
          </div>
        </div>

        <button
          class="btn dropdown-btn"
          type="button"
          :id="'dropdownMenuButton' + postObj.id"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="material-icons p-0">expand_more</i>
        </button>
        <div
          class="dropdown-menu"
          :aria-labelledby="'dropdownMenuButton' + postObj.id"
        >
          <a
            class="dropdown-item"
            href="javascript:void(0)"
            v-if="isSelfPost"
            @click="deletePendingPost(postObj.id)"
            >{{ deleteText }}</a
          >
          <a
            class="dropdown-item"
            href="javascript:void(0)"
            v-else
            @click="reportPost()"
            >{{ reportText }}</a
          >
        </div>
      </div>
    </template>

    <div>
      <h5 class="body-title">{{ postObj.title }}</h5>
      <p class="body-desc">{{ postObj.text }}</p>

      <template v-if="postObj.media && postObj.media.length">
        <div class="grid">
          <div v-for="mediaItem in postObj.media" v-bind:key="mediaItem.id">
            <MediaTile :media="mediaItem" />
          </div>
        </div>
      </template>

      <template v-if="postObj.scenarios && postObj.scenarios.length">
        <hr class="my-2" />
        <b class="scenario-heading">Attached Scenarios</b>
        <Scenario
          v-cloak
          v-bind:key="scenario.id"
          v-for="scenario in postObj.scenarios"
          :scenario="scenario"
        ></Scenario>
      </template>
    </div>
  </CommunityCard>
</template>

<script>
import forumGroupService from "../services/forumgroup.service";
import scenarioService from "../services/scenarios.service";
import Scenario from "./Scenario";
import CommunityCard from "./CommunityCard";
import MediaTile from "../components/MediaTile";
import {
  getForumPostPrettyDate,
  getFormattedDateStringFromDateString,
} from "@/utils/datetime.helper";
import logger from "@/utils/logger";

export default {
  name: "ForumPost",
  props: ["postObj", "groupObj"],
  components: {
    Scenario,
    CommunityCard,
    MediaTile,
  },
  data() {
    return {
      PRIVACY_LEVELS: {
        PRIVATE: 0,
        PUBLIC: 2,
      },
      reportText: "Report",
      deleteText: "Delete",
    };
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip({ delay: { show: 500, hide: 100 } });
  },
  computed: {
    isSelfPost() {
      let currentUserId = this.$store.getters.getUser.id;
      return this.postObj.creator.id === currentUserId;
    },
  },
  methods: {
    reportPost() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      this.reportText = "...";

      forumGroupService
        .reportPost(this.postObj.id)
        .then(() => {
          logger.log("forum.post.reported", "Post reported", { postId: this.postObj.id });
          this.showSuccess("Post reported");
        })
        .catch((reason) => {
          vm.$swal
            .mixin({
              customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-danger",
              },
              buttonsStyling: false,
            })
            .fire("Notice", reason, "info");
        })
        .finally(() => {
          this.isSubmitting = false;
          this.reportText = "Report";
        });
    },
    deletePendingPost() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      this.deleteText = "...";

      forumGroupService
        .deletePost(this.postObj.id)
        .then(() => {
          logger.log("forum.post.deleted", "Post deleted", { postId: this.postObj.id });
          this.$emit("reload-data");
          this.showSuccess("Post deleted");
        })
        .finally(() => {
          this.isSubmitting = false;
          this.deleteText = "Delete";
        });
    },
    downloadScenario(scenarioUuid) {
      scenarioService.downloadScenario(scenarioUuid).then((data) => {
        if (window.webkit) {
          window.webkit.messageHandlers.scenarioimport.postMessage({
            url: data.url,
            fileName: data.fileName,
          });
        } else {
          window.location = data.url;
        }
      });
    },
    getFullDate(dateString) {
      return getFormattedDateStringFromDateString(dateString);
    },
    getPrettyDate(dateString) {
      return getForumPostPrettyDate(dateString);
    },
    goToGroup(groupId) {
      this.$router.push({
        name: "forum-group",
        params: { groupId: groupId },
      });
    },
    showSuccess(msg) {
      vm.$swal
        .mixin({
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        })
        .fire("Success!", msg, "success");
    },
  },
};
</script>

<style scoped>
.post-card {
  margin: 0 auto 16px;
  padding: 16px;
}

.dropdown-btn {
  line-height: 1;
  color: #d2d2d2;
}

.time-text {
  color: var(--gray);
  font-size: 12px;
}

.titlerow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.body-desc {
  font-size: 16px;
}

.scenario-heading {
  font-size: 0.7em;
  margin-bottom: 4px;
  text-transform: uppercase;
  color: var(--gray);
}

h5.post-title {
  font-size: 16px;
  color: var(--dark);
  margin-bottom: 0;
}

h5.body-title {
  font-size: 20px;
  font-weight: 500;
  color: var(--dark);
}
</style>
